module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/sns_1-e4a6dbec0d1e69c56ed86887ae8146cf.png";